import React, { useState } from 'react'
import { Row, Col } from 'antd'
import ProjectList from './list'
import ProjectForm from './projectForm'
import { useSelector } from 'react-redux'

export default function Add() {
    const langValue = useSelector(state => state.langList.value)
    const [addedProject, setAddedProject] = useState();
    const addSuccess = (data) => {
        // console.log('add success:', data);
        const { donationItem, permission, deadline, projectStatus } = data;
        let obj = { '捐款项目': donationItem, '权限': permission, '停用日期': deadline, '状态': projectStatus };
        setAddedProject(obj);
    }

    return (
        <div className="set-area">
            <Row>
                {/* 左边新建项目组件 */}
                <Col xs={10} sm={10} md={10} lg={10} xl={8} style={{ backgroundColor: "#fff", paddingLeft: 24, paddingTop: 12 }} key="left">
                    <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#0c145a' }}><div style={{ borderLeft: '4px solid #0c145a', paddingRight: 10 }} />{langValue==0?'新建项目New project':(langValue==1?'新建项目':'New project')}</h1>
                    <ProjectForm handleSuccess={addSuccess} />
                </Col>
                {/* 右边项目列表 */}
                <Col xs={10} sm={10} md={10} lg={10} xl={16} style={{ backgroundColor: "white", border: '1px solid #eee', paddingLeft: 24, paddingTop: 12 }} key="right">
                    <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#0c145a' }}><div style={{ borderLeft: '4px solid #0c145a', paddingRight: 10 }} />{langValue==0?'项目列表Project list':(langValue==1?'项目列表':'Project list')}</h1>
                    <ProjectList {...{ addedProject }} />
                </Col>
            </Row>
        </div >
    )
}
